import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { Stage } from './components';
import { OfferStage } from 'api';
import { offerStageArr } from './constants';
import { getOfferState } from './helpers';
const FINAL_STAGES = [OfferStage.Won, OfferStage.Lost, OfferStage.Canceled];
export const OfferStageBar = ({ stage, onStageChange }) => {
    const data = useMemo(() => {
        const isFinalStage = FINAL_STAGES.includes(stage);
        const filteredStages = isFinalStage
            ? offerStageArr.filter((item) => item.stage === stage || !FINAL_STAGES.includes(item.stage))
            : offerStageArr;
        const statusIndex = filteredStages.findIndex((os) => os.stage === stage);
        return filteredStages.map((item, index) => (Object.assign(Object.assign({}, item), { position: index === filteredStages.length - 1 && isFinalStage ? 'last' : item.position, state: index === filteredStages.length - 1 && isFinalStage
                ? 'complete'
                : getOfferState(statusIndex, index) })));
    }, [stage]);
    return (_jsx(Card, Object.assign({ className: 'p-3 mb-0 d-flex flex-row w-100' }, { children: data.map(({ stage, position, state }) => (_jsx(Stage, { position: position, stage: stage, state: state, onClick: onStageChange }, stage))) })));
};
